<h2 mat-dialog-title>
  <div class="dialog-title-grid cancel-account-title-grid">
    <div class="left-col dialog-title-left">
      Are you sure?
    </div>
    <div class="right-col dialog-title-right">
      <button mat-icon-button aria-label="Close" (click)="close()" class="dialog-title-close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</h2>
<mat-dialog-content>
  <div *blockUI="'loadingUI'; template:blockTemplate;">
    <p>
      <strong>Final Access Date:</strong>your subscription will remain active until {{ cancellationDate | date:'longDate' }}. <br>
      <strong>Team Access:</strong> On this date, you and all team members will lose access to the workspace.<br>
      <strong>Access Status:</strong> Access to all evidence and narratives will be <strong>permanently discontinued</strong>. This access is non-retrievable and cannot be restored by our staff or through a new subscription. <br><br>
      <strong>Are you sure you want to proceed with cancellation?</strong>
    </p>
    @if(error()) {
      <div class="error">{{ error() }}</div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <app-weave-button
    [classes]="'secondary'"
    [text]="'Keep Account'"
    (click)="close()"
    ></app-weave-button>
  <app-weave-button
    [classes]="'action-alert'"
  [text]="'Cancel Account'"
  (click)="cancelAccount()"
  [disabled]="loading()"
  >
  </app-weave-button>
</mat-dialog-actions>
